import { Label } from "@/components/ui/label";

interface FormFieldProps {
  label?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  controlWrapperClassName?: string;
}

export function FormField({
  label,
  className = "",
  controlWrapperClassName = "h-10",
  children,
}: FormFieldProps) {
  return (
    <div
      className={`flex flex-col gap-1.5 items-start relative shrink-0 w-full ${className}`}
    >
      {label ? <Label>{label}</Label> : null}
      <div className={`w-full ${controlWrapperClassName}`}>{children}</div>
    </div>
  );
}

export default FormField;
